import { Component, ElementRef, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import Debug from 'debug';
import { CanSize, CanSizeCtor, mixinSize } from '../style/CanSize';
const debug = Debug('aumico:core:AumicoPagination');

class AumPaginationBase {
    constructor(public _elementRef: ElementRef) {}
}
const _AumPaginationMixinBase: CanSizeCtor & typeof AumPaginationBase = mixinSize(AumPaginationBase, 'medium');

@Component({
    selector: 'aum-back-forth',
    templateUrl: 'pagination.html',
    styleUrls: ['pagination.scss'],
    host: {
        class: 'aum-back-forth',
    },
    encapsulation: ViewEncapsulation.None,
    inputs: ['size'],
})
export class AumPagination extends _AumPaginationMixinBase implements CanSize {
    @Output() clickBack = new EventEmitter();
    @Output() clickForth = new EventEmitter();

    constructor(el: ElementRef) {
        super(el);
    }

    onClickBack() {
        debug('onClickBack');
        this.clickBack.emit();
    }

    onClickForth() {
        debug('onClickForth');
        this.clickForth.emit();
    }
}
